export default {
  CLEAR_SKILL_STATE: (state) => (state.skills = []),

  store: (state, payload) => {
    state.skills = [...state.skills, { ...payload }];
  },
  delete: (state, payload) => {
    let _skills = [...state.skills];
    _skills = [
      ..._skills.slice(0, payload.index),
      ..._skills.slice(payload.index + 1),
    ];

    state.skills = [..._skills];
  },
  index: (state, payload) => (state.skills = [...payload]),
};
